<template>
  <section >
    <transition :name="isMobile ? 'slideNotifDownMobile' : 'slideNotifDown'">
      <div class="notifications" v-if="state">
        <span class="arrow"></span>
        <span class="arrow arrow-mask"></span>
        <div class="notifications-panel">
          <header>
            <div class="heading">
              <span>Central</span>
              <h3>Notificações</h3>
            </div>
            <div class="header-action">
              <a href="#" @click.prevent="show(!read)" class="showAll">
                <span>Exibir lidas</span>
                <div :class="['exibSwitch', {active: read}]">
                  <span></span>
                </div>
              </a>
            </div>
          </header>
          <div class="notifications-body">
            <ol v-if="notifications.length > 0">
              <li v-for="notification in notifications" :key="notification.idNotificacao || notification.timestamp" :class="['notification-item', notification.type, { unread: notification.read == 0 }]">
                <div class="notification-content">
                  <div class="notification-title">
                    <span class="icon-box">
                      <fa :icon="parseContent(notification.type, 'icon')" class="iconWrap" />
                    </span>
                    <div>
                      <h6>{{ notification.title || notification.titile || parseContent(notification.type,'title') }}</h6>
                      <p v-html="notification.msg"></p>
                    </div>
                  </div>
                  <span class="timer">
                    <fa :icon="['fas','clock']" class="icon"/>
                    <p>{{ fromNow(notification.timestamp) }}</p>
                  </span>
                </div>
                <div class="notification-select">
                  <label :class="['checkbox-large', { checked: notification.selected }]" v-if="notification.read == 0">
                    <fa :icon="['fass', 'check']" class="icon"></fa>
                    <input type="checkbox" v-model="notification.selected">
                  </label>
                  <span class="read-chip" v-else>Lida</span>
                </div>
              </li>
            </ol>
            <div class="empty" v-else>
              <span class="empty-icon">
                <fa :icon="['fal', 'bell-slash']" />
              </span>
              <h4>Tudo certo por aqui</h4>
              <p>Você não tem novas notificações no momento.</p>
            </div>
          </div>
          <footer>
            <a href="#" @click.prevent="markAsRead(true)" :class="{ disabled: !notifications.some( a => a.read == 0) }">
              Marcar todas como lidas
            </a>
            <a href="#" @click.prevent="markAsRead()" :class="['btn btn-primary',{ disabled: !notifications.some( a => a.selected) }]">
              Marcar como lida
            </a>
          </footer>
        </div>
      </div>
    </transition>
    <div class="backdrop" @click="toggleClose()" v-if="state"></div>
  </section>
</template>

<script>
import NotificacaoService from '@/services/notifications.service.js'
import { fromNow } from '@/services/utils.service.js'

export default {
  props: {
    scope: {
      type: Array
    },
    state: {
      type: Boolean,
      default: false
    },
    config: {
      type: Array
    }
  },
  watch: {
    scope ( value ) {
      this.notifications = value
    },
    state ( value ) {
      if ( value ) {
        const self = this
        document.onkeydown = function(e) {
          if (e.key == 'Escape') {
            self.toggleClose()
          }
        } 
      } else {
        document.onkeydown = null
      }
    }
  },
  data () {
    return {
      notifications: [],
      read: false,
      isMobile: window.innerWidth <= 1024,
      slideLoop: null
    }
  },
  mounted () {
    window.addEventListener('resize', this.checkSize)
  },
  methods: {
    checkSize () {
      if ( this.slideLoop ) clearInterval(this.slideLoop)

      this.slideLoop = setTimeout(() => {
        this.isMobile = window.innerWidth <= 1024
      }, 200)
    },
    parseContent (type, target) {
      const fallback = this.config && this.config.length ? this.config[0] : {}
      const match = this.config ? this.config.filter( a => a.type == type)[0] : null
      return match ? match[target] : fallback[target]
    },
    markAsRead ( all ) {
      const data = []

      this.notifications.map(k => {
        if ( k.read == 0 ) {
          if ( all ) {
            data.push(k.idNotificacao)
          } else {
            if ( k.selected ) data.push(k.idNotificacao)
          }
        }
      })

      NotificacaoService.markAsRead(data).then(
        () => {
          this.$emit('refreshList')
        },
        () => {

        }
      )
    },
    toggleClose() {
      this.$emit('close')
    },
    fromNow ( timestamp ) {
      return fromNow(timestamp)
    },
    show ( all ) {
      this.read = all
      this.$emit('get', all)
    }
  }
}
</script>

<style lang="scss" scoped>
  .notifications {
    position: absolute;
    z-index: 1000;
    width: 440px;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%, 100%);
    @extend %transition_4e;
    
    .arrow {
      display: block;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: 1px solid #dbe5ee;
      background: #ffffff;
      transform: rotate(45deg);
      position: absolute;
      top: -6px;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 1;

      &.arrow-mask {
        z-index: 3;
        border: 0;
        background: #ffffff;
        top: -4px;
      }
    }

    @media screen and (max-width: 1024px) {
      position: fixed;
      width: calc(100% - 32px);
      left: 0;
      right: 0;
      margin: auto;
      transform: none;
      top: 16px;
      pointer-events: none;

      .arrow {
        display: none
      }

      .notifications-panel {
        pointer-events: all
      }
    }

    .notifications-panel {
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 2;
      width: 100%;
      height: auto;
      max-height: min(640px, calc(100vh - 120px));
      overflow: hidden;
      background: #ffffff;
      border: 1px solid #dbe5ee;
      border-radius: 16px;
      box-shadow: 0 22px 54px rgba(12, 34, 52, 0.18);

      header {
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        border-bottom: 1px solid #e6eef5;

        .heading {
          display: flex;
          flex-direction: column;
          gap: 4px;

          > span {
            color: #6f8190;
            font-size: 10px;
            font-weight: 800;
            letter-spacing: .04em;
            text-transform: uppercase;
          }
        }

        h3 {
          line-height: 1;
          padding: 0;
          margin: 0;
          color: #08243a;
          font-size: 24px;
          font-weight: 800;
        }

        .header-action {
          text-align: right
        }

        .showAll {
          display: flex;
          align-items: center;
          gap: 10px;
          min-height: 34px;
          padding: 0 4px 0 12px;
          color: #607382;
          font-size: 12px;
          font-weight: 700;
          border: 1px solid #dbe5ee;
          border-radius: 999px;
          background: #f6f9fb;

          .exibSwitch{ 
            width: 34px;
            height: 20px;
            border-radius: 2em;
            background: #a8b6c2;
            position: relative;
            @extend %transition_3o;

            > span {
              width: 14px;
              height: 14px;
              border-radius: 100%;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 3px;
              @extend %transition_3o;
              background: #ffffff;
              box-shadow: 0 2px 6px rgba(0,0,0,.14);
            }

            &.active {
              background: $color-primary;

              > span {
                left: 17px;
              }
            }
          }
        }
      }

      footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        padding: 16px 20px;
        background: #ffffff;
        border-top: 1px solid #e6eef5;

        a {
          color: #6f8190;
          font-size: 12px;
          font-weight: 700;

          &.btn {
            min-width: 150px;
            min-height: 40px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            border-radius: 999px;
            box-shadow: 0 10px 24px rgba(255, 0, 54, .18);
          }
        }

        a.disabled {
          opacity: .4;
          pointer-events: none;
        }
      }

      .notifications-body {
        flex: 1;
        height: auto; 
        @extend %scrollbar_light;
        overflow-y: auto;
        background: #f6f9fb;
      }

      ol {
        padding: 10px;
        margin: 0;
        
        .notification-item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 14px;
          margin-bottom: 8px;
          border: 1px solid #e1ebf2;
          border-radius: 12px;
          background: #ffffff;
          @extend %transition_3o;

          &.unread {
            border-color: #cdeaf4;
            box-shadow: inset 3px 0 0 $color-primary;
          }

          .notification-content {
            flex: 1;
            min-width: 0;
          }

          &:last-child{
            margin-bottom: 0;
          }

          .notification-title {
            display: flex;
            align-items: flex-start;
            gap: 12px;

            .icon-box {
              width: 34px;
              height: 34px;
              min-width: 34px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 10px;
              background: #fff6d8;
            }

            .iconWrap {
              font-size: 14px;
            }

            h6 {
              margin: 0 0 4px 0;
              color: #08243a;
              font-size: 13px;
              font-weight: 800;
              line-height: 1.25;
            }

            p {
              margin: 0;
              color: #6f8190;
              font-size: 12px;
              line-height: 1.45;
              white-space: normal;
              word-break: break-word;
            }
          }

          &:hover {
            border-color: #c6d7e3;
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(12,34,52,.08);

            .checkbox-large {
              border-color: $color-primary;
            }
          }

          &.apollo {
            .icon-box { background: #fff6d8; }
            .iconWrap, h6 { color: $color-notificacao; }
          }
          &.sincronismo {
            .icon-box { background: #ddf8fb; }
            .iconWrap, h6 { color: $color-sincronismo; }
          }
          &.atividades {
            .icon-box { background: #e3f8ed; }
            .iconWrap, h6 { color: $color-atividades; }
          }
          &.relatorios {
            .icon-box { background: #eeedff; }
            .iconWrap, h6 { color: $color-relatorio; }
          }
          &.jarvis {
            .icon-box { background: #fff2f5; }
            .iconWrap, h6 { color: $color-jarvis; }
          }

          .notification-select {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            min-width: 34px;
          }

          .checkbox-large {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 28px;
            height: 28px;
            background: #f6f9fb;
            border-radius: 8px;
            border: 1px solid #dbe5ee;
            position: relative;
            cursor: pointer;
            @extend %transition_3o;

            .icon {
              font-size: 14px;
              color: transparent;
              @extend %transition_3o
            }
            &.checked {
              background: #fff2f5;
              border-color: $color-primary;

              .icon {
                font-size: 14px;
                color: $color-primary;
              }
            }
            input {
              opacity: 0;
              z-index: -1;
              position: absolute;
            }
          }

          .read-chip {
            display: inline-flex;
            align-items: center;
            min-height: 24px;
            padding: 0 9px;
            color: #8092a1;
            font-size: 10px;
            font-weight: 800;
            text-transform: uppercase;
            background: #edf3f7;
            border-radius: 999px;
          }
        }
      }
    }

    .checkReadToggle {
      font-size: 16px;
      
      &:hover {
        color: $color-primary
      }
    }

    .timer {
      display: flex;
      align-items: center;
      align-content: center;
      margin-top: 10px;
      color: #8b9aa7;
      font-size: 11px;
      font-weight: 700;
      .icon {
        margin-right: 6px
      }
      p {
        margin: 0;
      }
    }
  }

  .backdrop { 
    width: 100vw; height: 100vh;
    background: transparent;
    position: fixed; z-index: 900;
    left: 0; top: 0;
  }

  .empty {
    padding: 48px 26px;
    text-align: center;
    color: #6f8190;

    .empty-icon {
      width: 48px;
      height: 48px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 14px;
      color: #8b9aa7;
      font-size: 20px;
      background: #edf3f7;
      border-radius: 14px;
    }

    h4 {
      margin: 0 0 6px 0;
      color: #08243a;
      font-size: 15px;
      font-weight: 800;
    }

    p {
      margin: 0;
      font-size: 12px;
    }
  }
  
  .slideNotifDown-enter-active, .slideNotifDown-leave-active {
    transform: translate(-50%, 100%); opacity: 1;
  }

  .slideNotifDown-enter-from, .slideNotifDown-leave-to {
    transform: translate(-50%, 90%); opacity: 0;
  }

  .slideNotifDownMobile-enter-active, .slideNotifDownMobile-leave-active {
    transform: translateY(0); opacity: 1;
  }

  .slideNotifDownMobile-enter-from, .slideNotifDownMobile-leave-to {
    transform: translateY(-50%); opacity: 0;
  }
</style>
